import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, state, animate, transition, keyframes, query, group} from '@angular/animations';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";

declare var $ :any;

@Component({
  selector: 'app-case-practice-p-and-o-previous',
  animations: [
    trigger(
    'wrapAnimation', [
      transition(':enter', [
        style({opacity: 0}),
        animate('200ms', style({opacity: 1}))
      ]),
      transition('* => void', animate('200ms', style({opacity: 0})))
    ]),
    trigger('nextStepAnimation', [
      state('hideNextStep', style({transform: 'translate(-300%)'})),
      state('showNextStep', style({transform: 'translate(0%)'})),
      transition('hideNextStep => showNextStep', animate('500ms', keyframes([
        style({transform: 'translate(-150%)', opacity: 0.2}),
        style({transform: 'translate(-90%)', opacity: 0.5}),
        style({transform: 'translate(-60%)', opacity: 1}),
        style({transform: 'translate(-40%)', opacity: 1}),
        style({transform: 'translate(-20%)', opacity: 1}),
        style({transform: 'translate(0%)', opacity: 1})
      ]))),
      transition('showNextStep => hideNextStep', animate('500ms', keyframes([
        style({transform: 'translate(0)', opacity: 1}),
        style({transform: 'translate(20%)', opacity: 1}),
        style({transform: 'translate(40%)', opacity: 1}),
        style({transform: 'translate(60%)', opacity: 1}),
        style({transform: 'translate(90%)', opacity: 0.5}),
        style({transform: 'translate(150%)', opacity: 0.2})
      ]))),
    ]),
    trigger('description1Animation', [
      state('hideDescription1', style({transform: 'translate(-300%)', opacity: 0})),
      state('showDescription1', style({transform: 'translate(0%)', opacity: 1})),
      transition('hideDescription1 => showDescription1', animate('500ms', keyframes([
        style({transform: 'translate(-150%)', opacity: 0.2}),
        style({transform: 'translate(-90%)', opacity: 0.5}),
        style({transform: 'translate(-60%)', opacity: 1}),
        style({transform: 'translate(-40%)', opacity: 1}),
        style({transform: 'translate(-20%)', opacity: 1}),
        style({transform: 'translate(0%)', opacity: 1})
      ]))),
      transition('showDescription1 => hideDescription1', animate('500ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('description2Animation', [
      state('hideDescription2', style({transform: 'translate(-300%)', opacity: 0})),
      state('showDescription2', style({transform: 'translate(0%)', opacity: 1})),
      transition('hideDescription2 => showDescription2', animate('500ms', keyframes([
        style({transform: 'translate(-150%)', opacity: 0.2}),
        style({transform: 'translate(-90%)', opacity: 0.5}),
        style({transform: 'translate(-60%)', opacity: 1}),
        style({transform: 'translate(-40%)', opacity: 1}),
        style({transform: 'translate(-20%)', opacity: 1}),
        style({transform: 'translate(0%)', opacity: 1})
      ]))),
      transition('showDescription2 => hideDescription2', animate('500ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('glAnimation', [
      state('hideGlBox', style({transform: 'scale(0.1, 0.1)', opacity: 0})),
      state('showGlBox', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideGlBox => showGlBox', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showGlBox => hideGlBox', animate('200ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('wlnAnimation', [
      state('hideWlnBox', style({transform: 'scale(0.1, 0.1)', opacity: 0})),
      state('showWlnBox', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideWlnBox => showWlnBox', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showWlnBox => hideWlnBox', animate('200ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('fkkAnimation', [
      state('hideFkkBox', style({transform: 'scale(0.1, 0.1)', opacity: 0})),
      state('showFkkBox', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideFkkBox => showFkkBox', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showFkkBox => hideFkkBox', animate('200ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('qfAnimation', [
      state('hideQfBox', style({transform: 'scale(0.1, 0.1)', opacity: 0})),
      state('showQfBox', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideQfBox => showQfBox', animate('200ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showQfBox => hideQfBox', animate('200ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('icon0Animation', [
      state('hideIcon0', style({opacity: 0, transform: 'scale(0.1, 0.1)', zIndex: -1})),
      state('showIcon0', style({opacity: 1, transform: 'scale(1, 1)', zIndex: 2})),
      transition('hideIcon0 => showIcon0',  animate('500ms', keyframes([
          style({transform: 'scale(0.3, 0.3)', opacity: 0.1, zIndex: 2}),
          style({transform: 'scale(0.35, 0.35)', opacity: 0.2, zIndex: 2}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.3, zIndex: 2}),
          style({transform: 'scale(0.45, 0.45)', opacity: 0.4, zIndex: 2}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5, zIndex: 2}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6, zIndex: 2}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7, zIndex: 2}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8, zIndex: 2}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9, zIndex: 2}),
          style({transform: 'scale(1, 1)', opacity: 1, zIndex: 2})
        ])
      )),
      transition('showIcon0 => hideIcon0', animate('200ms', keyframes([
          style({transform: 'scale(1, 1)', opacity: 1}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1})
        ])
      ))
    ]),
    trigger('icon1Animation', [
      state('hideIcon1', style({opacity: 0, transform: 'scale(0.1, 0.1)', zIndex: -1})),
      state('showIcon1', style({opacity: 1, transform: 'scale(1, 1)', zIndex: 2})),
      transition('hideIcon1 => showIcon1',  animate('500ms', keyframes([
          style({transform: 'scale(0.3, 0.3)', opacity: 0.1, zIndex: 2}),
          style({transform: 'scale(0.35, 0.35)', opacity: 0.2, zIndex: 2}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.3, zIndex: 2}),
          style({transform: 'scale(0.45, 0.45)', opacity: 0.4, zIndex: 2}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5, zIndex: 2}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6, zIndex: 2}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7, zIndex: 2}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8, zIndex: 2}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9, zIndex: 2}),
          style({transform: 'scale(1, 1)', opacity: 1, zIndex: 2})
        ])
      )),
      transition('showIcon1 => hideIcon1', animate('200ms', keyframes([
          style({transform: 'scale(1, 1)', opacity: 1}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1})
        ])
      ))
    ]),
    trigger('icon2Animation', [
      state('hideIcon2', style({opacity: 0, transform: 'scale(0.1, 0.1)', zIndex: -1})),
      state('showIcon2', style({opacity: 1, zIndex: 2})),
      transition('hideIcon2 => showIcon2',  animate('500ms', keyframes([
          style({transform: 'scale(0.3, 0.3)', opacity: 0.1, zIndex: 2}),
          style({transform: 'scale(0.35, 0.35)', opacity: 0.2, zIndex: 2}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.3, zIndex: 2}),
          style({transform: 'scale(0.45, 0.45)', opacity: 0.4, zIndex: 2}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5, zIndex: 2}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6, zIndex: 2}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7, zIndex: 2}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8, zIndex: 2}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9, zIndex: 2}),
          style({transform: 'scale(1, 1)', opacity: 1, zIndex: 2})
        ])
      )),
      transition('showIcon2 => hideIcon2', animate('200ms', keyframes([
          style({transform: 'scale(1, 1)', opacity: 1}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1})
        ])
      ))
    ]),
    trigger('icon3Animation', [
      state('hideIcon3', style({opacity: 0, transform: 'scale(0.1, 0.1)', zIndex:-1})),
      state('showIcon3', style({opacity: 1, zIndex:2})),
      transition('hideIcon3 => showIcon3',  animate('500ms', keyframes([
          style({transform: 'scale(0.3, 0.3)', opacity: 0.1, zIndex: 2}),
          style({transform: 'scale(0.35, 0.35)', opacity: 0.2, zIndex: 2}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.3, zIndex: 2}),
          style({transform: 'scale(0.45, 0.45)', opacity: 0.4, zIndex: 2}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5, zIndex: 2}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6, zIndex: 2}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7, zIndex: 2}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8, zIndex: 2}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9, zIndex: 2}),
          style({transform: 'scale(1, 1)', opacity: 1, zIndex: 2})
        ])
      )),
      transition('showIcon3 => hideIcon3', animate('200ms', keyframes([
          style({transform: 'scale(1, 1)', opacity: 1}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1})
        ])
      ))
    ]),
    trigger('timeTableAnimation', [
      state('hideTimeTable', style({transform: 'scale(0.1, 0.1)', opacity: 0})),
      state('showTimeTable', style({transform: 'scale(1, 1)', opacity: 1})),
      transition('hideTimeTable => showTimeTable', animate('500ms', keyframes([
        style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
        style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
        style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
        style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
        style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
        style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
        style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
        style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
        style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
        style({transform: 'scale(1, 1)', opacity: 1})
      ]))),
      transition('showTimeTable => void', animate('200ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
    trigger('earthAnimation', [
      state('hideEarth', style({opacity: 1, transform: 'rotate(-25deg)', transformOrigin: '50% 200%', zIndex: 1})),
      state('showEarth', style({opacity: 1, transform: 'rotate(0deg)', transformOrigin: '50% 200%', zIndex: 1})),
      transition('hideEarth => showEarth', animate('500ms', keyframes([
        style({transform: 'rotate(-25deg)', opacity: 1, transformOrigin: '50% 200%'}),
        style({transform: 'rotate(-20deg)', opacity: 1, transformOrigin: '50% 200%'}),
        style({transform: 'rotate(-15deg)', opacity: 1, transformOrigin: '50% 200%'}),
        style({transform: 'rotate(-10deg)', opacity: 1, transformOrigin: '50% 200%'}),
        style({transform: 'rotate(-5deg)', opacity: 1, transformOrigin: '50% 200%'}),
        style({transform: 'rotate(0deg)', opacity: 1, transformOrigin: '50% 200%'}),
        // style({transform: 'rotate(25deg)', opacity: 1, transformOrigin: '50% 100%', height: '11.5rem', width: '24rem', left: '-8.5rem', top: '1.15rem'}),
        // style({transform: 'rotate(30deg)', opacity: 1, transformOrigin: '50% 100%', height: '11.5rem', width: '24rem', left: '-8.5rem', top: '1.15rem'})
      ]))),
      transition('showTimeTable => void', animate('200ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0.8}),
        style({opacity: 0.6}),
        style({opacity: 0.4}),
        style({opacity: 0.2}),
        style({opacity: 0})
      ]))),
    ]),
  ],
  templateUrl: './case-practice-p-and-o-previous.component.html',
  styleUrls: ['./case-practice-p-and-o-previous.component.css',]
})
export class CasePracticePAndOPreviousComponent implements OnInit, AfterViewInit {
    @Input() exerciseId:number;
  //接受传入的参数 用于判断是否为访客
    @Input() userType: string;
    @Output() onGoToNextStep = new EventEmitter<any>();

    step: number;
    peopleNumber: number;
    taskNumber: number;

    clickable: boolean;

    status: number;

    nextStepShow: boolean;
    description1Show: boolean;
    description2Show: boolean;
    glBoxShow: boolean;
    wlnBoxShow: boolean;
    fkkBoxShow: boolean;
    qfBoxShow: boolean;
    icon0Show: boolean;
    icon1Show: boolean;
    icon2Show: boolean;
    icon3Show: boolean;
    timeTableShow: boolean;
    earthShow: boolean;
  assetsRoute: string = "../../assets";

  constructor(
      private commonService:CommonService,
      private apiService: ApiService,
      private route: ActivatedRoute,
      private router: Router
  ){}

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    let that = this;
    this.glBoxShow = false;
    this.wlnBoxShow = false;
    this.fkkBoxShow = false;
    this.qfBoxShow = false;
    this.icon0Show = false;
    this.icon1Show = false;
    this.icon2Show = false;
    this.icon3Show = false;
    this.nextStepShow = false;
    this.description1Show = false;
    this.description2Show = false;
    this.timeTableShow = false;
    this.earthShow = false;
    console.log('exerciseId:'+this.exerciseId);
    this.apiService.ajax({
        'type':'get',
        'url':'/api/pnoQuestion/'+this.exerciseId
    }).subscribe(result=>{
      this.status = result.status;
      // 如果是访客永远从头开始情景模拟剧情
      if(this.userType){
         this.status = 0;
      }
      if(this.status==0){
        this.step =0;
        this.peopleNumber = 0;
        this.taskNumber = 0;
        setTimeout(function(){
           that.nextStepShow = true;
        }, 1000);
        $('#wrap').fadeTo('slow', 0.3, function(){
          $(this).css('background-image', 'url("../../assets/picture/casepracticepando/bg1.png")');
        }).fadeTo('slow', 1);
        setTimeout(function(){
          that.clickable = true;
        }, 2000);
      }else if(this.status==5){
        this.step =3;
        this.taskNumber = 0;
        setTimeout(function(){
          that.description2Show = true;
        }, 1000);
        $('#wrap').fadeTo('slow', 0.3, function(){
          $(this).css('background-image', 'url("../../assets/picture/casepracticepando/bg1.png")');
        }).fadeTo('slow', 1);
        setTimeout(function(){
            that.clickable = true;
        }, 2000);
      }else if(this.status == 10){
        this.step =5;
        this.timeTableShow = true;
        $('#wrap').fadeTo('slow', 0.3, function(){
          $(this).css('background-image', 'url("../../assets/picture/casepracticepando/China.png")');
        }).fadeTo('slow', 1);
        setTimeout(function(){
            that.clickable = true;
        }, 1000);
      }
    });
  }

    ngAfterViewInit(){
      this.commonService.initPage({
          'backgroundColor':'white'
      });
      document.oncontextmenu = function (e) {
          e.preventDefault();
      }
    }

  screenClick(){
    if(!this.clickable){
      return;
    }
    let _this = this;
    if(this.step == 0){
      this.step = 1;
      this.clickable = false;
      this.nextStepShow = false;
      // $('#reviewBox').fadeIn();
      setTimeout(function () {
        _this.description1Show = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
    }else if(this.step == 1){
      this.clickable = false;
      if(this.peopleNumber==0){
        this.peopleNumber = 1;
        this.description1Show = false;
        setTimeout(function () {
          $('#gl').fadeIn(200);
          _this.glBoxShow = true;
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }else if(this.peopleNumber == 1){
        this.peopleNumber = 2;
        this.glBoxShow = false;
        setTimeout(function () {
          $('#wln').fadeIn(200);
          _this.wlnBoxShow = true;
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }else if(this.peopleNumber == 2){
        this.peopleNumber = 3;
        this.wlnBoxShow = false;
        setTimeout(function () {
          $('#fkk').fadeIn(200);
          _this.fkkBoxShow = true;
          setTimeout(function(){
            _this.clickable = true;
          }, 1000);
        }, 1000);
      }else if(this.peopleNumber == 3){
        this.step = 2;
        this.fkkBoxShow = false;
        setTimeout(function () {
          $('#qf').fadeIn(200);
          _this.qfBoxShow = true;
          setTimeout(function(){
            _this.clickable = true;
          },  1000);
        }, 1000);
      }
    }else if(this.step==2){
      this.step = 3;
      this.clickable = false;
      $('#gl').fadeOut(200);
      $('#wln').fadeOut(200);
      $('#fkk').fadeOut(200);
      $('#qf').fadeOut(200);
      this.qfBoxShow = false;
      this.apiService.ajax({
        'type':'post',
        'url':'/api/pnoStorePoint/'+this.exerciseId,
        'data':{
            'pno_store_point_id':5
        }
      }).subscribe(result=>{});
      setTimeout(function () {
        _this.description2Show = true;
        setTimeout(function(){
          _this.clickable = true;
        },  1000);
      }, 1000);
    }else if(this.step == 3){
      this.clickable = false;
      if(this.taskNumber == 0){
        this.taskNumber = 1;
        this.description2Show = false;
        $('#wrap').fadeTo('fast', 0.3, function(){
          $('#wrap').css('background', '#ffffff');
          // $(this).css('background-image', 'url("../../assets/picture/casepracticepando/bg2.png")');
          $("#earth").fadeIn(200, function(){
            _this.icon0Show = true;
          });
        }).fadeTo('fast', 1);
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }else{
        let oldIndex = this.taskNumber - 1;
        let currentIndex = this.taskNumber;
        if(this.taskNumber<3){
          this.taskNumber ++;
        }else{
          this.step = 4;
        }
        if(oldIndex == 0){
          this.icon0Show = false;
          this.earthShow = true;
          setTimeout(function () {
           // $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/China.png")');
            setTimeout(function(){
              _this.icon1Show = true;
              setTimeout(function(){
                _this.clickable = true;
              }, 1000);
            }, 1000);
          }, 1000);
        }else if(oldIndex == 1){
          this.icon1Show = false;
          setTimeout(function () {
            _this.icon2Show = true;
            setTimeout(function(){
              _this.clickable = true;
            }, 1000);
          }, 1000);
        } else if(oldIndex == 2){
          this.icon2Show = false;
          setTimeout(function () {
            _this.icon3Show = true;
            setTimeout(function(){
              _this.clickable = true;
            }, 1000);
          }, 1000);
        }
      }
    }else if(this.step == 4){
      this.clickable = false;
      this.step = 5;
      this.icon3Show = false;
      setTimeout(function () {
        // $('#timeTable').fadeIn(200);
        _this.timeTableShow = true;
        setTimeout(function(){
          _this.clickable = true;
        }, 1000);
      }, 1000);
      this.apiService.ajax({
        'type':'post',
        'url':'/api/pnoStorePoint/'+this.exerciseId,
        'data':{
            'pno_store_point_id':10
        }
      }).subscribe(result=>{});
    }else if(this.step == 5){
    	this.clickable = false;
      this.apiService.ajax({
        'type':'post',
        'url':'/api/pnoStorePoint/'+this.exerciseId,
        'data':{
            'pno_store_point_id':15
        }
      }).subscribe(result=>{
      	_this.onGoToNextStep.emit(true);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-p-and-o-previous/case-practice-p-and-o-previous.component.ts